import React, { useState } from "react";
import PropTypes from "prop-types";
import { Image } from "./styles";

const ProgressiveImg = ({ thumbnail, fullsize }) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <Image className="progressive-image-container flex flex-col mx-auto">
      <img
        src={thumbnail}
        className={`thumbnail-image ${imageLoaded ? "hidden" : ""}`}
        alt="Thumbnail"
      />
      <img
        src={fullsize}
        onLoad={() => setImageLoaded(true)}
        className={`fullsize-image ${imageLoaded ? "" : "hidden"}`}
        alt="Full Size"
      />
    </Image>
  );
};

ProgressiveImg.propTypes = {
  thumbnail: PropTypes.string.isRequired,
  fullsize: PropTypes.string.isRequired,
};

export default ProgressiveImg;



// WEBPACK FOOTER //
// ./app/javascript/bundles/ui/ProgressiveImg/index.jsx